import { c as t } from "./index.C4-GUKyp.js";
const a = t("tw-relative tw-rounded-4 tw-cursor-pointer tw-inline-flex tw-items-center tw-text-nowrap tw-outline-0 tw-outline-blue-800 focus-visible:tw-outline-2 tw-outline-offset-1 tw-bg-transparent", {
  variants: {
    variant: {
      "outline-1": "tw-border tw-border-solid",
      "outline-2": "tw-border tw-border-solid",
      default: "",
      ghost: "",
      "text-only": "",
      underline: "",
      "underline-m": ""
    },
    appearance: {
      white: "",
      black: "",
      purple: "",
      gray: "",
      destructive: ""
    },
    alignment: {
      left: "tw-justify-start tw-text-left",
      center: "tw-justify-center tw-text-center",
      right: "tw-justify-end tw-text-right"
    },
    size: {
      default: "tw-py-8 tw-px-16 tw-h-40",
      large: "tw-py-12 tw-px-20 tw-h-48"
    },
    disabled: {
      true: "tw-pointer-events-none",
      false: ""
    },
    showSpinner: {
      true: "tw-pointer-events-none",
      false: ""
    },
    fullWidth: {
      true: "tw-w-full",
      false: ""
    },
    iconOnly: {
      true: "",
      false: ""
    },
    prefix: {
      true: "",
      false: ""
    },
    suffix: {
      true: "",
      false: ""
    },
    shape: {
      default: "",
      pill: "tw-rounded-full tw-py-8 tw-px-12",
      circle: "tw-rounded-full tw-p-8 tw-aspect-square tw-inline-flex tw-items-center tw-justify-center"
    }
  },
  compoundVariants: [{
    size: "default",
    variant: ["default", "outline-1", "outline-2", "ghost", "text-only"],
    class: "tw-body-2-m"
  }, {
    size: "default",
    variant: "underline",
    class: "tw-body-2-underline tw-skip-ink-none"
  }, {
    size: "default",
    variant: "underline-m",
    class: "tw-body-2-m-underline tw-skip-ink-none"
  }, {
    size: "large",
    variant: ["default", "outline-1", "outline-2", "ghost", "text-only"],
    class: "tw-headline-2-m"
  }, {
    variant: "default",
    appearance: "black",
    class: "tw-bg-gray-900 tw-text-base-white hover:tw-bg-gray-800"
  }, {
    variant: "ghost",
    appearance: "black",
    class: "tw-text-gray-900 hover:tw-bg-gray-500/15"
  }, {
    variant: "ghost",
    appearance: "white",
    class: "tw-text-base-white hover:tw-bg-base-white/15"
  }, {
    variant: ["text-only", "underline", "underline-m"],
    appearance: "black",
    class: "tw-text-gray-900 hover:tw-text-gray-700"
  }, {
    variant: ["default", "outline-1", "outline-2"],
    appearance: "white",
    class: "tw-bg-base-white tw-text-gray-900 hover:tw-bg-gray-200"
  }, {
    variant: "outline-1",
    appearance: "white",
    class: "tw-border-gray-400"
  }, {
    variant: "outline-2",
    appearance: "white",
    class: "tw-border-gray-900"
  }, {
    variant: ["text-only", "underline", "underline-m"],
    appearance: "white",
    class: "tw-text-base-white hover:tw-text-gray-500"
  }, {
    variant: ["text-only", "underline", "underline-m"],
    class: "tw-p-0 tw-h-auto"
  }, {
    variant: "default",
    appearance: "purple",
    class: "tw-bg-purple-600 tw-text-base-white hover:tw-bg-purple-700"
  }, {
    variant: ["text-only"],
    appearance: "purple",
    class: "tw-text-purple-600 hover:tw-text-purple-700"
  }, {
    variant: ["underline", "underline-m"],
    appearance: "purple",
    class: "tw-text-purple-900 hover:tw-text-purple-800"
  }, {
    variant: ["text-only", "underline", "underline-m"],
    appearance: "gray",
    class: "tw-text-gray-600 hover:tw-text-gray-800"
  }, {
    variant: "default",
    appearance: "destructive",
    class: "tw-bg-red-800 tw-text-base-white hover:tw-bg-red-900"
  }, {
    variant: "text-only",
    appearance: "destructive",
    class: "tw-text-red-800 hover:tw-text-red-900"
  }, {
    disabled: !0,
    appearance: ["black", "purple", "destructive"],
    variant: "default",
    class: "tw-bg-gray-200 tw-text-gray-500"
  }, {
    disabled: !0,
    appearance: ["black", "gray", "destructive"],
    variant: ["ghost", "text-only"],
    class: "tw-text-gray-500"
  }, {
    disabled: !0,
    appearance: ["white", "purple"],
    variant: ["ghost", "text-only"],
    class: "tw-text-gray-600"
  }, {
    disabled: !0,
    appearance: "white",
    variant: ["default", "outline-1", "outline-2", "ghost"],
    class: "tw-text-gray-500"
  }, {
    disabled: !0,
    appearance: "white",
    variant: ["outline-2"],
    class: "tw-border-gray-400"
  }, {
    size: "default",
    variant: ["default", "outline-1", "outline-2", "ghost"],
    prefix: !0,
    class: "tw-pl-12"
  }, {
    size: "default",
    variant: ["default", "outline-1", "outline-2", "ghost"],
    suffix: !0,
    class: "tw-pr-12"
  }, {
    size: "large",
    variant: ["default", "outline-1", "outline-2", "ghost"],
    prefix: !0,
    class: "tw-pl-16"
  }, {
    size: "large",
    variant: ["default", "outline-1", "outline-2", "ghost"],
    suffix: !0,
    class: "tw-pr-16"
  }, {
    iconOnly: !0,
    class: "tw-px-0"
  }, {
    iconOnly: !0,
    variant: ["default", "outline-1", "outline-2", "ghost"],
    size: "default",
    class: "tw-w-40 tw-min-w-40"
  }, {
    iconOnly: !0,
    variant: ["default", "outline-1", "outline-2", "ghost"],
    size: "large",
    class: "tw-w-48 tw-min-w-48"
  }, {
    shape: "pill",
    class: "tw-body-1-m sm:tw-h-36"
  }, {
    shape: "circle",
    class: "tw-body-1-m"
  }],
  defaultVariants: {
    variant: "default",
    appearance: "black",
    size: "default",
    alignment: "center",
    shape: "default"
  }
});
export {
  a as b
};
//# sourceMappingURL=button-variants.DWX6pG3S.js.map
